// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"55422039","703":"dff587ee","787":"1f809b1b"}[chunkId] + ".chunk.js";
};